import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/comprar-dados-colunas',
  component: DashBoardNav,
    children: [{
      path: '/comprar-dados-colunas',
      component: () => import('@/components/compra/comprarDadosColunas')
    }
  ]
}]
